import { combineReducers } from 'redux';
import { ACTIONS, SINGLE_PART_LEVELS, ROUND } from 'a/pictureThis/data/constants';

import * as fromCurriculum from 'a/pictureThis/content/curriculum';
import currentItem, * as fromCurrentItem from 'a/pictureThis/redux/reducers/currentItem';
import { shuffleArray } from '../../../../lib/utilityFunctions';

export const initialState = {
  isInteractionLocked: false,
  answerCount: {
    totalStories: 0,
    correct: 0,
    incorrect: 0,
  },
  levelIndex: 0,
  currentLevelIndex: 0,
  storyIndexes: [],
  currentPage: {
    index: 0,
    maxPage: 0,
  },
};

export const storyIndexes = (state = [], { type, payload }) => {
  switch (type) {
    case ACTIONS.START_NEW_ROUND:
    case ACTIONS.REPLAY_ONBOARDING:
      return payload.level > SINGLE_PART_LEVELS ? [1] : [0];

    case ACTIONS.SELECT_LEVEL:
      if (payload.level === 0) return state;
      return createShuffledArrayOfStoryIndexes(
        fromCurriculum.getTotalStoriesInLevel(payload.level),
      );
    case ACTIONS.ADVANCE_CONTENT:
      return state.slice(0, state.length - 1);
    default:
      return state;
  }
};

export const createShuffledArrayOfStoryIndexes = (amount) => {
  const bag = [];
  for (let i = 0; i < amount; i++) {
    bag.push(i);
  }
  return shuffleArray(bag);
};

export const answerCount = (state = initialState.answerCount, { type, payload }) => {
  switch (type) {
    case ACTIONS.SELECT_LEVEL:
      return initialState.answerCount;
    case ACTIONS.INCREASE_CORRECT_ELEMENT_COUNT:
      return {
        ...state,
        correct: state.correct + 1,
      };
    case ACTIONS.INCREASE_STORIES_COMPLETE_COUNT:
      return {
        ...state,
        totalStories: state.totalStories + 1,
      };
    case ACTIONS.INCREASE_INCORRECT_ELEMENT_COUNT:
      return {
        ...state,
        incorrect: state.incorrect + 1,
      };
    case ACTIONS.QUICK_ROUND:
      return {
        ...state,
        correct: payload.pass ? ROUND.STORIES_PER_LEVEL : 0,
        incorrect: payload.pass ? 0 : ROUND.STORIES_PER_LEVEL,
      };
    default:
      return state;
  }
};

export const isInteractionLocked = (state = false, { type, payload }) => {
  switch (type) {
    case ACTIONS.SELECT_LEVEL:
      return false;
    case ACTIONS.SET_IS_INTERACTION_LOCKED:
      return payload;
    default:
      return state;
  }
};

export const levelIndex = (state = 0, { type, payload }) => {
  switch (type) {
    case ACTIONS.SELECT_LEVEL:
      return payload.level;
    default:
      return state;
  }
};

export const currentLevelIndex = (state = 0, { type, payload }) => {
  switch (type) {
    case ACTIONS.START_NEW_ROUND:
    case ACTIONS.REPLAY_ONBOARDING:
      return payload.level;
    default:
      return state;
  }
};

export const currentPage = (state = initialState.currentPage, { type, payload }) => {
  switch (type) {
    case ACTIONS.SELECT_LEVEL:
      return initialState.currentPage;

    case ACTIONS.CREATE_VIEW_MODEL_FROM_CONTENT:
      return {
        ...state,
        index: 0,
        maxPage: fromCurriculum.getStoryPageCount(payload.levelIndex, payload.contentIndex),
      };

    case ACTIONS.NEXT_PAGE:
      return {
        ...state,
        index: state.index + 1 < state.maxPage ? state.index + 1 : state.index,
      };
    case ACTIONS.PREVIOUS_PAGE:
      return {
        ...state,
        index: state.index - 1 >= 0 ? state.index - 1 : state.index,
      };
    default:
      return state;
  }
};

const currentRound = combineReducers({
  isInteractionLocked,
  levelIndex,
  currentLevelIndex,
  currentPage,
  currentItem,
  storyIndexes,
  answerCount,
});

export default currentRound;

// selectors
export const getStoryScript = state =>
  fromCurriculum.getStoryScript(
    getLevelIndex(state),
    getContentIndex(state),
  );

export const getStoryScriptPage = state =>
  fromCurriculum.getStoryScriptPage(
    getLevelIndex(state),
    getContentIndex(state),
    getPageIndex(state),
  );

export const getPageIndex = state => state.currentPage.index;

export const getContentIndex = state => getStackTop(state.storyIndexes);

const getStackTop = (array) => {
  const length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
};

export const getLevelIndex = state => state.levelIndex;

export const getCurrentLevelIndex = state => state.currentLevelIndex;

export const getStoryId = state =>
  fromCurriculum.getStoryId(
    getLevelIndex(state),
    getContentIndex(state),
  );

export const getMaxPage = state => state.currentPage.maxPage;

export const getIsInteractionLocked = state => state.isInteractionLocked;

export const getIncorrectAnswerCount = state => state.answerCount.incorrect;

export const getCorrectAnswerCount = state => state.answerCount.correct;

export const getTotalStoriesAnswered = state => state.answerCount.totalStories;

export const getHelpCount = state =>
  fromCurrentItem.getHelpCount(state.currentItem);

export const getIsScaffold = state =>
  fromCurrentItem.getIsScaffold(state.currentItem);

export const getTriesCount = state =>
  fromCurrentItem.getTriesCount(state.currentItem);

export const getTriesCountOnCurrentElement = state =>
  fromCurrentItem.getTriesCountOnCurrentElement(state.currentItem);
